 import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchAllEnquiry,contactEnquirySelector } from '../../api/contactenquiry'
import Datatable from './datatable'
import ExportExcel from './exportExcel'
 
 export default function Index() {
    const dispatch = useDispatch()
    const {all_contact} = useSelector(contactEnquirySelector)
    console.log({all_contact})
    useEffect(()=>{
        dispatch(fetchAllEnquiry())
    },[dispatch])
   return (
    <>
    <div className="mb-4 float-right ">
    <div className="mx-3">

 
    <ExportExcel data = {all_contact}/>
    
</div>
</div>


 <Datatable data ={all_contact}/>


    </>
   )
 }
 
